import { onMounted, ref } from 'vue';
import BibConfiguracaoService from '@/services/biblioteca/bibconfiguracao/bibconfiguracao.service';
import toastService from '@/services/globals/toast.service';

export function useEdicaoExemplar() {
  const editarTombamento = ref(false);
  const editarCodigoBarras = ref(false);

  async function carregarConfiguracaoEdicao() {
    editarTombamento.value = false;
    editarCodigoBarras.value = false;
    try {
      const configuracao = await BibConfiguracaoService.get();
      editarTombamento.value = Number(configuracao?.editarTombamento) === 1;
      editarCodigoBarras.value = Number(configuracao?.editarCodigoBarras) === 1;
    } catch {
      toastService.alertaErro('Não foi possível carregar a configuração de edição. Tombamento e código de barras permanecerão somente para leitura.');
    }
  }

  onMounted(carregarConfiguracaoEdicao);
  return { editarTombamento, editarCodigoBarras, carregarConfiguracaoEdicao };
}
